export default function Loader({ size = 16 }: { size?: number }) {
  const bars = Array(12).fill(0);

  return (
    <>
      <div className="loader relative flex items-center justify-center">
        <div className="sonner-loading-wrapper absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 transition w-[--size] h-[--size] z-10">
          <div className="relative top-1/2 left-1/2 h-[--size] w-[--size]">
            {bars.map((_, i) => (
              <div className="loading-bar" key={`spinner-bar-${i}`} />
            ))}
          </div>
        </div>
      </div>

      <style>
        {`
            @keyframes spin {
              0% {
                opacity: 1;
              }
              100% {
                opacity: 0.15;
              }
            }
  
            .loader {
              --size: ${size}px;
              --color: currentColor;
            }
  
            .loading-bar {
              animation: spin 1.2s linear infinite;
              background: var(--color);
              border-radius: 6px;
              height: 8%;
              left: -10%;
              position: absolute;
              top: -3.9%;
              width: 24%;
            }
  
            .loading-bar:nth-child(1) {
              animation-delay: -1.2s;
              transform: rotate(0.0001deg) translate(146%);
            }
  
            .loading-bar:nth-child(2) {
              animation-delay: -1.1s;
              transform: rotate(30deg) translate(146%);
            }
  
            .loading-bar:nth-child(3) {
              animation-delay: -1s;
              transform: rotate(60deg) translate(146%);
            }
  
            .loading-bar:nth-child(4) {
              animation-delay: -0.9s;
              transform: rotate(90deg) translate(146%);
            }
  
            .loading-bar:nth-child(5) {
              animation-delay: -0.8s;
              transform: rotate(120deg) translate(146%);
            }
  
            .loading-bar:nth-child(6) {
              animation-delay: -0.7s;
              transform: rotate(150deg) translate(146%);
            }
  
            .loading-bar:nth-child(7) {
              animation-delay: -0.6s;
              transform: rotate(180deg) translate(146%);
            }
  
            .loading-bar:nth-child(8) {
              animation-delay: -0.5s;
              transform: rotate(210deg) translate(146%);
            }
  
            .loading-bar:nth-child(9) {
              animation-delay: -0.4s;
              transform: rotate(240deg) translate(146%);
            }
  
            .loading-bar:nth-child(10) {
              animation-delay: -0.3s;
              transform: rotate(270deg) translate(146%);
            }
  
            .loading-bar:nth-child(11) {
              animation-delay: -0.2s;
              transform: rotate(300deg) translate(146%);
            }
  
            .loading-bar:nth-child(12) {
              animation-delay: -0.1s;
              transform: rotate(330deg) translate(146%);
            }
            `}
      </style>
    </>
  );
}
